<template>
  <el-dialog
    :visible="visible"
    :title="$t('CargoMsg.Cargo_TriggerConditionConfiguration')"
    :before-close="cancel"
    width="800px"
    append-to-body
    class="rule-configuration-dialog"
  >
    <div style="display: flex; margin: 10px">
      <el-form label-width="70px" label-position="left">
        <el-form-item :label="$t('CargoMsg.Cargo_RuleConditions')" required>
          <cargo-advance-select
            style="width: 240px"
            :static-options="ruleConditions"
            clearable
            tag-value="code"
            :default-value="ruleMode"
            required
            @parentCallBack="p=>{ruleMode=p.value}"
          />
        </el-form-item>
      </el-form>
      <el-button style="margin-left: 386px" type="danger" @click="onDel(null)">{{ $t('Menu.delete') }}</el-button>
    </div>
    <div class="grid">
      <cargo-ag-grid
        :column-defs="columnDefs"
        :grid-options="gridOptions"
        :row-data="rowData"
        :show-side-bar="false"
        style="height:100%;min-height: 340px;"
        @rowDataChanged="rowDataChanged"
      />
    </div>
    <template slot="footer">
      <div>
        <el-button type="primary" @click="onSave">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import { deepClone } from '@/utils'
import * as WorkflowConstants from '@/class/cargo/model/parameters/WorkflowConstants'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import { DocumentManage } from '@/utils/commonUtil'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CustomLabelUtils from '@/utils/CustomLabelUtils'
import { getFilterCacheList } from '@/utils/basicDataCache'
export default {
  name: 'RuleConfigConditionDialog',
  components: { CargoAgGrid, cargoAdvanceSelect },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: { type: Array, default: () => [] },
    rules: { type: Array, default: () => [] },
    workflow: { type: Object, default: () => {} },
    visible: { type: Boolean, default: () => false }
  },
  data() {
    return {
      rowData: [],
      isAll: false,
      dialogVisible: false,
      searchValue: '',
      selectedRows: null,
      displayName: '',
      gridApi: null,
      loading: null,
      gridOptions: {
        rowSelection: 'multiple',
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridAdvanceSelectEditor
        },
        onSortChanged: this.rowDataChanged
      },
      editable: true,
      selectedData: null,
      selectedBak: '',
      ruleConditions: Array.from(WorkflowConstants.RULE_CONDITIONS),
      documentManage: new DocumentManage(),
      cmpList: [],
      currencyList: [],
      ruleMode: null
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '', width: 55, checkboxSelection: true,
          headerCheckboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 25,
          sortable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ConditionalItem'),
          field: 'column',
          flex: 1,
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: params => {
            return {
              selectProps: {
                filterable: true
              },
              options: this.rules,
              tagName: 'alias',
              tagValue: 'column',
              style: 'width: 100%'
            }
          },
          cellRenderer: params => {
            const list = this.rules
            if (!list || list.length === 0) {
              return ''
            }
            const data = list.filter(item => item.column === params.value)
            if (!data || data.length === 0) {
              return ''
            }
            return data[0].alias
          },
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ConditionalRule'),
          field: 'operator',
          flex: 1,
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: params => {
            const list = this.rules
            if (!list || list.length === 0) {
              return []
            }
            const data = list.filter(item => item.column === params.data.column)
            const array = (!data || data.length === 0) ? [] : JSON.parse(data[0].operator)
            return {
              selectProps: {
                filterable: true
              },
              options: array,
              tagName: 'operatorAlias',
              tagValue: 'operator'
            }
          },
          cellRenderer: params => {
            const list = this.rules
            if (!list || list.length === 0) {
              return params.value
            }
            const data = list.filter(item => item.column === params.data.column)
            if (!data || data.length === 0 || !data[0].operator) {
              return params.value
            }
            const array = JSON.parse(data[0].operator)
            const result = array.filter(item => item.operator === params.value)
            if (!result || result.length === 0) {
              return params.value
            }
            return result[0].operatorAlias
          },
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ConditionalValue'),
          field: 'value',
          flex: 1,
          editable: true,
          cellEditorSelector: params => {
            // 结算对象 or 委托单位
            if (params.data.column === 'customerId') {
              return {
                component: 'CargoAgGridAdvanceSelectEditor',
                params: {
                  selectProps: {
                    selectType: TYPE_NAMES.basic_data_Company,
                    tagValue: 'cmpIdx',
                    tagName: 'chineseName',
                    methodParams: { active: true, customer: true },
                    autoKey: 'auto_0',
                    dataFilterFunction: (item, inputVal) => {
                      if (item.cmpIdx === inputVal) {
                        return true
                      }
                      return true
                      // return this._view.config.isInputChargeBaseOnService
                    },
                    filterable: true,
                    staticOptions: this.cmpList
                  }
                }
              }
            }
            // 币种
            if (params.data.column === 'currency') {
              return {
                component: 'CargoAgGridAdvanceSelectEditor',
                params: {
                  selectProps: {
                    tagValue: 'code',
                    tagName: 'code',
                    staticOptions: this.currencyList,
                    filterable: true,
                    filterTagNames: ['code']
                  }
                }
              }
            }
            const list = this.rules
            const editor = {
              component: 'CargoAgGridCommonInputEditor',
              params: {
                inputProps: {
                  style: 'width: 100%'
                }
              }
            }
            if (!list || list.length === 0) {
              return editor
            }
            const data = list.filter(item => item.column === params.data.column)
            if (!data || data.length === 0 || !data[0].value) {
              return editor
            }
            const array = (!data || data.length === 0 || !data[0].value) ? [] : JSON.parse(data[0].value)
            if (array.type !== 'enum') {
              const isNumber = array.type === 'integer' || array.type === 'double'
              if (isNumber) {
                editor.params.isNumber = isNumber
                editor.params.inputProps.precision = array.type === 'integer' ? 0 : 2
              }
              return editor
            }
            return {
              component: 'CargoAgGridSelectEditor',
              params: {
                selectProps: {
                  filterable: true
                },
                options: array.data,
                tagName: 'valueAlias',
                tagValue: 'value'
              }
            }
          },
          cellRenderer: params => {
            // console.log('params.data.column' + params.data.column)
            // 结算对象
            if (params.data.column === 'customerId') {
              return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0')
            }
            const list = this.rules
            if (!list || list.length === 0) {
              return params.value
            }
            const data = list.filter(item => item.column === params.data.column)
            if (!data || data.length === 0 || !data[0].value) {
              return params.value
            }
            const array = JSON.parse(data[0].value)
            if (array.type !== 'enum') {
              return params.value
            }
            const result = array.data.filter(item => item.value === params.value)
            if (!result || result.length === 0) {
              return params.value
            }
            return result[0].valueAlias
          },
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          }
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'operation',
          suppressMenu: true,
          width: 140,
          cellRenderer: params => {
            const onAdd = this.documentManage.getPath('onAdd')
            const onDel = this.documentManage.getPath('onDel')
            return `<div>
                        <a onclick="${onAdd}()" style="color:#1F75D5;font-size:25px;">+</a>
                        <a onclick="${onDel}(${params.data.serialNumber})" style="color:#1F75D5;font-size:25px;">-</a>
                      </div>`
          }
        }]
    }
  },
  watch: {
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onAdd', function() {
      context.onAdd()
    })
    this.documentManage.set('onDel', function(value) {
      context.onDel(value)
    })
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.rowData = deepClone(this.workflow.subConditionList)
      this.ruleMode = this.workflow.ruleMode
      if (!this.rowData || this.rowData.length === 0) {
        this.rowData = []
        this.onAdd()
      } else {
        ColumnUtils.addSerialNumber(this.rowData)
      }
      if (this.rules.filter(rule => rule.column === 'customerId') !== -1) {
        this.cmpList = getFilterCacheList(TYPE_NAMES.basic_data_Company)
      }
      if (this.rules.filter(rule => rule.column === 'currency') !== -1) {
        this.currencyList = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency)
      }
    },
    onAdd() {
      const newConfiguration = {
        type: 1,
        column: '',
        operator: '',
        value: '',
        id: 'serialNumber_' + this.rowData.length
      }
      this.rowData.push(newConfiguration)
      ColumnUtils.addSerialNumber(this.rowData)
    },
    onDel(serialNumber) {
      if (serialNumber !== null) {
        this.rowData = this.rowData.filter(row => row.serialNumber !== serialNumber)
      } else {
        const api = this.gridOptions.api
        const selRows = api.getSelectedRows() // 获取选中的行
        api.updateRowData({ remove: selRows })
        const rowData = []
        api.forEachNode(node => rowData.push(node.data))
        this.rowData = rowData
      }
      if (this.rowData.length === 0) {
        this.onAdd()
      } else {
        ColumnUtils.addSerialNumber(this.rowData)
      }
    },
    onSave() {
      this.workflow.ruleMode = this.ruleMode
      if (WorkflowConstants.RULE_CONDITIONS_NONE.code === this.workflow.ruleMode) {
        this.workflow.subConditionList = []
      } else {
        this.workflow.subConditionList = this.rowData
        if (this.checkData()) {
          return
        }
      }
      this.$emit('change', this.workflow)
      this.cancel()
    },
    cancel() {
      this.$emit('close')
    },
    // 重复数据校验
    checkData() {
      if (!this.rowData || this.rowData.length === 0) {
        return false
      }
      const map = {}
      for (const data of this.rowData) {
        const key = data.column + data.operator + data.value
        if (map.hasOwnProperty(key)) { // 数据重复校验
          this.$message.warning(this.$t('CargoMsg.Cargo_ThereIsDuplicateData'))
          return true
        }
        map[key] = true
        // 数据值校验
        // if (!data.type) {
        //   this.$message.warning(this.$t('CargoMsg.Cargo_TriggerType') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        //   return true
        // }
        if (!data.column) {
          this.$message.warning(this.$t('CargoMsg.Cargo_FilterDimension') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
          return true
        }
        if (!data.operator) {
          this.$message.warning(this.$t('CargoMsg.Cargo_Operation') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
          return true
        }
        if (!data.value) {
          this.$message.warning(this.$t('CargoMsg.Cargo_FilterValue') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
          return true
        }
      }
      return false
    },
    onCellChange(params) {
      // console.log('params:' + JSON.stringify(params.data))
      // console.log('params:' + params.value)
      if (params.newValue === params.oldValue) {
        return
      }
      if (params.colDef.field === 'type') {
        params.data.column = ''
        params.data.operator = ''
        params.data.value = ''
      }
      if (params.colDef.field === 'column') {
        params.data.operator = ''
        params.data.value = ''
      }
      if (params.colDef.field === 'operator') {
        params.data.value = ''
      }
      if (params.colDef.field === 'value' && params.newValue > 1000000000) {
        params.data.value = 999999999.99
      }
      this.gridOptions.api.refreshCells({ force: true })
    },
    rowDataChanged(params) {
      this.sortChanged(params, this.columnDefs, this.rowData)
    },
    sortChanged(params, columnDefs, rowData) {
      let serialNumber = 0
      const nodes = params.api.rowModel.rowsToDisplay
      nodes.forEach(node => {
        const row = rowData.filter(row => {
          return (row.uuid || row.id) === (node.data.uuid || node.data.id)
        })[0]
        row.serialNumber = ++serialNumber
      })
      params.api.refreshCells({ force: true })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/element-variables.scss";
.rule-configuration-dialog{
  .operation {
    display: flex;
    justify-content: space-between;
  }
  .grid {
    display: flex;
    /deep/.el-select {
      width: 100%;
    }
  }
  .el-dialog__footer{
    display: flex;
    text-align: left;
    .blue {
      color: $--color-primary
    }
  }
}

</style>
